import { api } from '../plugins/axios';
import { Paged } from '../types/common';
import {
  CreatePopUpTargetBranchDto,
  PopUpTargetBranch,
  UpdatePopUpTargetBranchDto,
} from '../types/popupTargetBranch';

export const getPopUpTargetBranches = (
  query?: string,
  page?: number,
  itemsPerPage?: number
) => {
  const params = {
    page: page || 1,
    itemsPerPage: itemsPerPage || 30,
  };
  return api.get<Paged<PopUpTargetBranch>>(
    `/admin/pop-up-target-branches?${query}`,
    {
      params,
    }
  );
};

export const getPopUpTargetBranch = (id: number) => {
  return api.get<PopUpTargetBranch>(`/admin/pop-up-target-branches/${id}`);
};

export const postPopUpTargetBranch = (
  data: Partial<CreatePopUpTargetBranchDto>
) => {
  return api.post<PopUpTargetBranch>(`/admin/pop-up-target-branches`, data);
};

export const patchPopUpTargetBranch = (
  id: number,
  data: Partial<UpdatePopUpTargetBranchDto>
) => {
  return api.patch<PopUpTargetBranch>(
    `/admin/pop-up-target-branches/${id}`,
    data
  );
};
